import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

const transactionsSearchSchema = z.object({
  search: z.string().optional(),
  transfer_type: z.string().optional(),
  transfer_status: z.string().optional(),
  min_amount: z.string().optional(),
  max_amount: z.string().optional(),
  start_at: z.string().optional(),
  end_at: z.string().optional(),
  page: z.union([z.string(), z.number()]).optional(),
  limit: z.union([z.string(), z.number()]).optional(),
});

export const transactionsRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/transactions',
  validateSearch: transactionsSearchSchema,
  component: lazyRouteComponent(() => import('@/pages/transactions/transactions-page')),
});

export const detailTransactionsRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/transactions/$id',
  component: lazyRouteComponent(() => import('@/pages/transactions/detail')),
});
